import React, { useState } from 'react';
import { Typography, Modal, Table } from 'antd';
import { accSub } from '../default';

const tableStyle = {
  margin: '20px'
};
const columns = [
  {
    title: '商品',
    align: 'center',
    dataIndex: 'sku_name'
  },
  {
    title: '已发货数量',
    align: 'center',
    dataIndex: 'deliver_number',
  },
  {
    title: '未发货数量',
    align: 'center',
    dataIndex: 'not_receive_goods',
    // render: (text, record) => (<span>{+(record.sale_number) - (+(record.deliver_number))}</span>)
    render: (text, record) => (<span>{accSub((record.sale_number), (record.deliver_number))}</span>)
  },
  {
    title: '已收货数量',
    align: 'center',
    dataIndex: 'receive_number',
  }
];

export default function RenderNumberPopover(props = {}) {
  const [modalVisible, setModalVisible] = useState(false);
  const { info = [] } = props;
  const finallyText = <Typography.Link style={{ width: '40px' }} onClick={() => openModal()}>收货明细</Typography.Link>;;
  const openModal = () => {
    setModalVisible(true);
  };
  const handleCancel = () => {
    setModalVisible(false);
  };
  return (<>
    <div> {finallyText}</div>
    <Modal
      open={modalVisible}
      centered
      footer={false}
      onCancel={handleCancel}
      width={700}
    >
      <Table
        style={tableStyle}
        bordered
        dataSource={info || []}
        columns={columns}
        rowKey='id'
        pagination={false}
      />
    </Modal>
  </>);
}
